import React from 'react';
import { platformLogos } from '../data/mock';

const PlatformBadge = ({ text }) => (
  <div className="flex items-center justify-center px-10 py-5 mx-1 min-w-[200px]">
    <span className="text-2xl font-bold tracking-tight text-slate-400 hover:text-slate-700 transition-colors duration-200 whitespace-nowrap">
      {text}
    </span>
  </div>
);

export default function PlatformsMarquee() {
  const logos = [...platformLogos, ...platformLogos];
  return (
    <section className="py-14 border-y border-slate-100 bg-slate-50/50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm font-semibold uppercase tracking-widest text-slate-500 mb-8">
          Works with your favorite platforms
        </p>
      </div>
      <div className="relative w-full overflow-hidden">
        <div className="flex w-max animate-marquee">
          {logos.map((logo, idx) => (
            <PlatformBadge key={`${logo.name}-${idx}`} text={logo.text} />
          ))}
        </div>
        {/* Edge fade */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-slate-50 to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-slate-50 to-transparent" />
      </div>
    </section>
  );
}
